var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RequestsTableRedesigned',{attrs:{"api-url-props":'/v2/requests?over_due=true',"title":"Over Due Requests"}})}
var staticRenderFns = []

export { render, staticRenderFns }